export const body = {
    height: "500px",
    backgroundColor: "#FAF3F3",
    display: "flex",
    flex: "1",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
};
